/** Trigger a browser download / navigation using a temporary anchor (no extra deps). */
export function downloadFileViaAnchor(url, filename) {
    if (!url || typeof document === 'undefined') return;
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    if (filename) a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
}
